export class ParameterValue {
    public name: string = '';
    public value: any = null;
}
